import { render, staticRenderFns } from "./ConfigTabPastas.vue?vue&type=template&id=762a12ae&scoped=true"
import script from "./ConfigTabPastas.vue?vue&type=script&lang=js"
export * from "./ConfigTabPastas.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabPastas.vue?vue&type=style&index=0&id=762a12ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762a12ae",
  null
  
)

export default component.exports